// extracted by mini-css-extract-plugin
export default {"tab_container":"tabs_tab_container__efVDc","tab_sub_container":"tabs_tab_sub_container__K1uAI","tab_values":"tabs_tab_values__e+PPJ"};